import { WidgetAPI } from "@/context/widget-context";
import { Language, useTranslations } from "@/lib";
import { Button } from "../ui/button";
import { ProductItem } from "./products/product-item";
export function Summary({
  widget,
  lang,
}: {
  widget: WidgetAPI;
  lang: Language;
}) {
  const { t, loading } = useTranslations(lang);
  return (
    <>
      <span className="tw:text-base tw:font-pp-fragment tw:font-medium tw:px-4">
        {t("summary.text_one")}
      </span>
      <div className="tw:grid tw:gap-5 tw:px-4 tw:pt-4">
        <span>{`${t("summary.text_two")}${
          widget.products.filter((product) => product.size).length > 1
            ? "s"
            : ""
        }`}</span>
        {widget.products
          .filter((product) => product.size)
          .map((product, index) => (
            <ProductItem key={index} product={product} lang={lang} />
          ))}

        {widget.products.some((product) => !product.size) && (
          <>
            <span>{t("summary.text_three")}</span>
            {widget.products
              .filter((product) => !product.size)
              .map((product, index) => (
                <ProductItem key={index} product={product} lang={lang} />
              ))}
          </>
        )}
      </div>
    </>
  );
}
export function SummaryButton({
  lang,
  widget,
}: {
  lang: Language;
  widget: WidgetAPI;
}) {
  const { t } = useTranslations(lang);
  return (
    <Button
      onClick={() => widget.setStep(5)}
      className="tw:!text-sm tw:md:!text-base tw:w-full tw:!h-13.5"
    >
      {t("schedule_free_trial_button_text")}
    </Button>
  );
}
